import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import BaseLayout from '../src/components/BaseLayout'; // Import the base layout component
import { AuthContext, AuthProvider } from './context/AuthProvider';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './context/ProtectedRoute';
import Services from './components/Services';
import ToDo from './components/ToDo';

function App() {
  return (
    <AuthProvider>
    <Routes>
      <Route path="/" element={<BaseLayout />}>
        <Route index element={<Home />} />
      </Route>
    </Routes>
    </AuthProvider>
  );
}

export default App;
